import React from 'react'
import SEO from '../../seo/SEO'
import Research_Development_Banner from './Research_Development_Banner/Research_Development_Banner'
import Research_Development_Second from './Research_Development_Second/Research_Development_Second'
import Research_Development_Third from './Research_Development_Third/Research_Development_Third'
import Research_Development_Forth from './Research_Development_Forth/Research_Development_Forth'
import Research_Development_fifth from './Research_Development_fifth/Research_Development_fifth'
import Research_Development_sixth from './Research_Development_sixth/Research_Development_sixth'

const Research_Development = () => {
  return (
    <>
    <SEO />
    <div>
 
        <Research_Development_Banner/>
        <Research_Development_Second/>
        <Research_Development_Third/>
        <Research_Development_Forth/>
        <Research_Development_fifth/>
        <Research_Development_sixth/>
    </div>
    </>
  )
}

export default Research_Development